import React, {Component} from 'react';
import PropTypes from 'prop-types';

import Error from 'lib/struct/form/Error';

import styles from './Select.less';

const {
	'select': select_class,
	'select-wrapper': select_wrapper_class,
	'select_invalid': invalid_select_class,
} = styles;

class Select extends Component {
	render() {
		const {className, wrapperClassName, emptyValueLabel, options, error, children, ...props} = this.props;

		const select_classes = [select_class];
		if (className) {
			select_classes.push(className);
		}

		const wrapper_classes = [select_wrapper_class];
		if (wrapperClassName) {
			wrapper_classes.push(wrapperClassName);
		}

		if (error) {
			select_classes.push(invalid_select_class)
		}

		return (
			<div className={wrapper_classes.join(' ')}>
				<select className={select_classes.join(' ')} {...props}>
					{
						children ? (children) : (
							options.map(({label, value, ...option}) => (
								<option
									key={value}
									value={value}
									{...option}
								>
									{!value && emptyValueLabel ? emptyValueLabel : label}
								</option>
							))
						)
					}
				</select>

				<Error error={error}/>
			</div>
		)
	}
}

Select.propTypes = {
	options: PropTypes.arrayOf(PropTypes.shape({
		label: PropTypes.any,
		value: PropTypes.any
	})).isRequired
};

export default Select;